import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '@env';

@Component({
  selector: 'app-privacy',

  templateUrl: './privacy.html',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyComponent {
  readonly businessInfo = environment.businessInfo;

  readonly contactInfo = this.businessInfo.contactInfo;

  readonly organisationAlias = this.businessInfo.organisationAlias;

  readonly tradeName = this.businessInfo.tradeName;
}
